import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { mainContext } from "../context/context";
import { ReactComponent as ImagineIcon } from "../Logo-Light.svg";
import Modal from "./Modal";
import FeedBackForm from "./FeedBackForm";
import { Mixpanel, MxEvent } from "../Mixpanel/Mixpanel";
import { getUserDetails, validateUser } from "../Helpers/helpers";
import Loader from "./Loader";
import { CREATE_INSPIRATIONS_ROUTE } from "../Helpers/constants";
import { IoMdClose } from "react-icons/io";
import AIVideo from "../assets/ai_video.mp4";
import JoinCommunity from "./JoinCommunity";

function Home() {
  const [pageLoading, setPageLoading] = useState(true);
  const { contextData, updateContextData } = useContext(mainContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);
  const [showVideo, setShowVideo] = useState(false);

  const navigate = useNavigate();

  const SKIP_TEXT = "SKIP_TEXT";

  useEffect(() => {
    if (!localStorage.getItem("alreadyVisitedHomePage") && !pageLoading) {
      // setShowVideo(true)
      localStorage.setItem("alreadyVisitedHomePage", true)
    }
  }, [pageLoading])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 500);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("click", () => {
      setShowVideo(false);
    });

    validateUser(setPageLoading);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("click", () => {
        setShowVideo(false);
      });
    };
  }, []);

  const getBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];
      callback("data:image/png;base64," + base64String);
    };
    reader.readAsDataURL(file);
  };

  const handleImageUpload = (e) => {
    const files = e.target.files;
    const file = files[0];

    if (file && file.type.startsWith("image/")) {
      getBase64(file, (_base64) => {
        updateContextData({
          product: {
            name: file?.name || "ProductImage.png",
            url: _base64,
            blobUrl: URL.createObjectURL(file),
          },
        });
        navigate(CREATE_INSPIRATIONS_ROUTE);
      });
    }
    document.body.removeChild(e.target);
  };

  const handleAddImage = (isMainImage) => {
    const _file = document.createElement("input");
    _file.accept = "image/*";
    _file.type = "File";
    _file.style.display = "none";
    _file.multiple = false;
    _file.onchange = (e) => handleImageUpload(e, isMainImage);
    document.body.appendChild(_file);
    _file.click();

    Mixpanel.track({
      eventName: MxEvent.CLICKED_CREATE_OR_UPLOAD_PRODUCT,
    });
  };

  if (pageLoading)
    return <Loader loading={pageLoading} backgroundColor="#fff" />;

  return (
    <>
      <div className="background App">
        <a href="https://imagine.io/">
          <ImagineIcon
            className={`logo ${isMobile && contextData?.product ? "left" : ""}`}
          />
        </a>
        <div className="text">
          {/* Create stunning visuals with the power of AI */}
          Imagine with AI
        </div>
        <div
          style={{
            display: "flex",
            gap: isMobile ? "0.75rem" : "1rem",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <div
            className={`generate-btn upload-btn btn`}
            onClick={() => {
              handleAddImage(true);
            }}
            style={isMobile ? { marginTop: 0 } : {}}
          >
            Select Your Product
          </div>
          <div
            className="inspiration-text"
            style={isMobile ? { marginTop: 0 } : {}}
          >
            or
          </div>

          <div
            className={`generate-btn upload-btn btn`}
            onClick={() => {
              updateContextData({ product: SKIP_TEXT });
              navigate(CREATE_INSPIRATIONS_ROUTE);
            }}
            style={isMobile ? { marginTop: 0 } : {}}
          >
            Create Inspirations
          </div>
        </div>
      </div>

      <div className={`feedback-footer align-center gap-2`}>
        {/* <div>This feature is still in alpha.</div> */}
        <div
          className="feedback"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            updateContextData({ showModal: true });
          }}
        >
          Give us your Feedback
        </div>
        |
        {JoinCommunity()}
      </div>

      {/* Feedback Form */}
      <Modal
        isOpen={contextData.showModal}
        onClose={() => updateContextData({ showModal: false })}
        title="Feedback"
      >
        <FeedBackForm />
      </Modal>

      {showVideo ? (
        <div className="ai-video-player">
          <div
            className="video-container"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <video
              id="ai-video-player"
              loop
              controls
              autoPlay
              playsInline
              controlsList="nodownload"
              onContextMenu={(e) => {
                e.preventDefault();
                return false;
              }}
            >
              <source src={AIVideo} type="video/mp4" />
            </video>
            <div className="closeIcon" onClick={() => setShowVideo(false)}>
              <IoMdClose />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Home;
